import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { DownArrowIcon } from "../../../@lib/icons";
import "./styles.css";
import { useLanguageTranslator } from "../../useLanguageContext";
import { Button } from "@mui/material";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";

function YearRangeSelector({ setFilters, filters }: any) {
  const [isFloatLabel, setIsFloatLabel] = useState(false);

  const { translator } = useLanguageTranslator();

  const handleYearChange = (newValue: any) => {
    if (Array.isArray(newValue) && newValue.length === 2) {
      const startYear = newValue[0] ? newValue[0].year : null;
      const endYear = newValue[1] ? newValue[1].year : null;

      setFilters({
        ...filters,
        startYear: startYear?.toString(),
        endYear: endYear?.toString(),
      });
    }
  };

  const yearRangeArray =
    filters?.startYear && filters?.endYear
      ? [filters?.startYear, filters?.endYear]
      : [];

  const currentYear = new Date().getFullYear();

  return (
    <>
      <div className="relative">
        <DatePicker
          value={yearRangeArray?.map((y: any) =>
            y ? new Date(y, 0, 1) : null
          )}
          onChange={handleYearChange}
          range
          onlyYearPicker
          format="YYYY"
          style={{
            height: "47px",
            borderRadius: "20px",
            paddingLeft: "15px",
            border: "0px",
            boxShadow: "0 5px 4px rgba(219, 219, 219, 0.25)",
          }}
          maxDate={new Date(currentYear, 11, 31)}
          plugins={[
            <DatePanel
              position="right"
              removeButton={true}
              onClickDate={(dateObject) => {
                setFilters({
                  ...filters,
                  startYear: "",
                  endYear: "",
                });
                setIsFloatLabel(false);
              }}
            />,
          ]}
        />

        <div
          style={{
            position: "absolute",
            right: 13,
            top: 0,
            display: "flex",
            alignItems: "center",
            height: "100%",
            transition: "transform 0.3s ease",
            transform: isFloatLabel ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          <DownArrowIcon />
        </div>
      </div>
    </>
  );
}

export { YearRangeSelector };